// CompanyEditNewCompanyFileFilterList - MODULE
// ***********************************************************************************************************************
import { Box } from "@mui/material";
import * as React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { IFileFilterListItem } from "../../../../models/fileFilter/fileFilterListItem";
import { List } from "../../../framework/List/List";

// CompanyEditNewCompanyFileFilterList
export interface ICompanyEditNewCompanyFileFilterListProp {
    items: IFileFilterListItem[];
    checkedIds: string[];
    onSetCheckedIds: (ids: string[]) => void;
}

export class CompanyEditNewCompanyFileFilterList extends React.Component<ICompanyEditNewCompanyFileFilterListProp, {}> {
    handleSetSelectedIds = (selectedId: string, checkedIds: string[]) => {
        this.props.onSetCheckedIds(checkedIds);
    };

    render() {
        const props = this.props;
        return (
            <Box sx={{ margin: "-1rem" }}>
                <List
                    intialized={true}
                    isLoading={false}
                    hasMore={false}
                    globalLoadingInUse={true}
                    header={{
                        columns: [
                            { size: 6, column: "code", content: Translations.Code },
                            { size: 6, column: "name", content: Translations.Name }
                        ]
                    }}
                    lines={props.items.map((item) => {
                        return {
                            columns: [
                                { size: 6, column: "code", content: item.code },
                                { size: 6, column: "name", content: item.name },
                            ],
                            id: item.id
                        };
                    })}
                    sortColumn={""}
                    sortOrderIsAsc={true}
                    selectedId={""}
                    checkedIds={props.checkedIds}
                    multiSelect={true}
                    onSetSelectedIds={this.handleSetSelectedIds}
                    onSearchLines={(sortColumn: string, sortOrderIsAsc: boolean, nextPage: boolean) => {}}
                />
            </Box>
        );
    }
}